/* One short explanation at a time. This component never submits a product form. */
(function () {
  'use strict';
  if (window.smkFeatureHelpInitialized) return;
  window.smkFeatureHelpInitialized = true;

  var active = null;
  var tip = document.createElement('div');
  tip.id = 'smkFeatureExplanation';
  tip.className = 'pf-feature-help';
  tip.setAttribute('role', 'tooltip');
  tip.hidden = true;
  document.body.appendChild(tip);

  function close() {
    if (!active) return;
    active.setAttribute('aria-expanded', 'false');
    active.removeAttribute('aria-describedby');
    active = null;
    tip.hidden = true;
    tip.textContent = '';
  }

  function init(root) {
    root.querySelectorAll('[data-feature-badges] img[data-feature-help]').forEach(function (img) {
      if (!img.dataset.featureHelp.trim() || img.closest('.pf-feature-button')) return;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'pf-feature-button';
      button.setAttribute('aria-label', img.alt || 'Feature information');
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', tip.id);
      img.before(button);
      button.appendChild(img);
    });
  }

  function open(button) {
    close();
    var img = button.querySelector('[data-feature-help]');
    if (!img || !button.isConnected) return;
    var viewport = window.visualViewport;
    var left = (viewport ? viewport.offsetLeft : 0) + 12;
    var top = (viewport ? viewport.offsetTop : 0) + 12;
    var right = left + (viewport ? viewport.width : window.innerWidth) - 24;
    var bottom = top + (viewport ? viewport.height : window.innerHeight) - 24;
    // The theme preview toolbar occupies real screen space during review.
    var preview = document.getElementById('PBarNextFrameWrapper');
    if (preview) {
      var bar = preview.getBoundingClientRect();
      if (bar.height && bar.top > top && bar.top < bottom) bottom = bar.top - 12;
    }
    var anchor = button.getBoundingClientRect();
    if (anchor.bottom <= top || anchor.top >= bottom || right <= left) return;
    tip.textContent = img.dataset.featureHelp;
    tip.style.width = Math.min(280, right - left) + 'px';
    tip.style.left = left + 'px';
    tip.style.top = top + 'px';
    tip.hidden = false;
    var rect = tip.getBoundingClientRect();
    var y = anchor.top - rect.height - 8;
    if (y < top) y = anchor.bottom + 8;
    // Do not cover the icon or squeeze text into a clipped, unreadable panel.
    if (y < top || y + rect.height > bottom) {
      tip.hidden = true;
      tip.textContent = '';
      return;
    }
    tip.style.left = Math.max(left, Math.min(anchor.left + (anchor.width - rect.width) / 2, right - rect.width)) + 'px';
    tip.style.top = y + 'px';
    active = button;
    active.setAttribute('aria-expanded', 'true');
    active.setAttribute('aria-describedby', tip.id);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.pf-feature-button');
    if (button) {
      if (button === active) close();
      else open(button);
    } else close();
  });
  document.addEventListener('pointerdown', function (event) {
    if (active && !active.contains(event.target) && !tip.contains(event.target)) close();
  }, true);
  document.addEventListener('focusin', function (event) {
    if (active && !active.contains(event.target)) close();
  });
  document.addEventListener('keydown', function (event) {
    if (!active) return;
    if ((event.key === 'Enter' || event.key === ' ') && event.target === active) return;
    close();
  }, true);
  // Dismiss at the start of scrolling, including nested scroll areas and swipes.
  window.addEventListener('scroll', close, { capture: true, passive: true });
  window.addEventListener('wheel', close, { capture: true, passive: true });
  window.addEventListener('touchmove', close, { capture: true, passive: true });
  window.addEventListener('resize', close);
  window.addEventListener('blur', close);
  window.addEventListener('pagehide', close);
  document.addEventListener('visibilitychange', close);
  document.addEventListener('toggle', function (event) {
    if (active && !active.contains(event.target)) close();
  }, true);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', close);
    window.visualViewport.addEventListener('scroll', close);
  }
  document.addEventListener('shopify:section:load', function (event) { close(); init(event.target); });
  document.addEventListener('shopify:section:unload', close);
  init(document);
})();
